import React from 'react';

import { LANGUAGES } from '../../constants';

export const LangContext = React.createContext(LANGUAGES.EN);
